import { number } from "prop-types";
import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { formatNumberWithCommas } from "Utilities/Number";

const FnrCampaignGraph = ({ goal, raised, pledged }) => {
  const [pledgedPercent, setPledgedPercent] = useState(0);
  const [raisedPercent, setRaisedPercent] = useState(0);

  function getFontSize(amount) {
    const rounded = Math.round(amount);
    if (rounded > 9999999) return "18px";
    else if (rounded > 999999) return "22px";
    else return "24px";
  }

  useEffect(() => {
    setPledgedPercent(Math.min((pledged / goal / 2) * 100, 50));
    setRaisedPercent(Math.min((raised / goal / 2) * 100, 50));
  }, [goal, pledged, raised]);

  return (
    <Wrapper data-cy="FnrCampaignGraph">
      <Pie style={{ "--p": 50 }} />
      {Number(pledged) > 0 && (
        <Pie
          style={{
            "--p": pledgedPercent,
            "--c": "#93C6E0",
            "--b": "18px",
            "--w": "194px",
            transform: "translateY(3px) rotate(-90deg)",
          }}
        />
      )}
      {Number(raised) > 0 && (
        <Pie
          style={{
            "--p": raisedPercent,
            "--c": "#278dc1",
            "--b": "18px",
            "--w": "194px",
            transform: "translateY(3px) rotate(-90deg)",
          }}
        />
      )}
      <Stats>
        <Pledged>${formatNumberWithCommas(Math.round(pledged))}</Pledged>
        <Goal>${formatNumberWithCommas(Math.round(goal))}</Goal>
        <Raised fontSize={getFontSize(raised)}>
          ${formatNumberWithCommas(Math.round(raised))}
        </Raised>
      </Stats>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
`;
const Stats = styled.div`
  margin-top: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 240px;
  font-size: 18px;
  font-weight: 400;
  position: relative;
`;
const Goal = styled.div``;
const Pledged = styled.div`
  text-align: center;
  &:after {
    content: "Pledged";
    text-transform: uppercase;
    font-size: 12px;
    display: block;
    text-align: center;
    line-height: 12px;
  }
`;
const Raised = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 600;
  height: 84px;
  margin-bottom: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &:after {
    content: "Raised";
    text-transform: uppercase;
    font-size: 14px;
    display: block;
    text-align: center;
    line-height: 14px;
  }
`;
const Pie = styled.div`
  --b: 24px;
  --c: #fff;
  --w: 200px;

  position: absolute;
  top: 0;

  width: var(--w);
  aspect-ratio: 1;
  display: inline-grid;
  place-content: center;
  transform: rotate(-90deg);
  &:before,
  &:after {
    content: "";
    position: absolute;
    border-radius: 50%;
  }
  &:before {
    inset: 0;
    background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b)
        var(--b) no-repeat,
      conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);
    -webkit-mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
    mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
  }
  &:after {
    inset: calc(50% - var(--b) / 2);
    background: var(--c);
    transform: rotate(calc(var(--p) * 3.6deg))
      translateY(calc(50% - var(--w) / 2));
  }
`;

FnrCampaignGraph.propTypes = {
  goal: number,
  raised: number,
  pledged: number,
};

export default FnrCampaignGraph;